import React, { Component } from "react";
import { connect } from "react-redux";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Tooltip } from "../../../../revvComponents";

import { FieldsSetting } from "../../../../actions";

import RevvFieldMapperBlock from "./RevvFieldMapperBlock";
// import SrcFieldMapperBlock from "./SrcFieldMapperBlock";
import FieldTransformerPopup from "../FieldTransformer";

const { updateFieldMappingAction, removeFieldMappingAction } = FieldsSetting;

class MappedField extends Component {
  state = {
    showTransformPopup: false,
    copyFieldMapping: null,
  };

  _addNewSourceField = (fieldName, revvField, fieldMapping) => {
    const { templateId } = this.props;
    const {
      mappingID,
      mapping: { source_fields: sourceFields = [] } = {},
      revvFieldID = revvField.id || null,
      revvSubField = revvField.sub_field || null,
    } = fieldMapping;

    const newField = { name: fieldName, transform: [] };
    const updatedSourceField = [...sourceFields, newField];
    const schema = {
      mapping: {
        ...(this.props.fieldMapping ? this.props.fieldMapping.mapping : {}),
        source_fields: updatedSourceField,
      },
      revvFieldID,
      revvSubField,
    };
    this.props.updateFieldMapping(mappingID, schema, templateId);
  };

  _removeSourceField = (fieldName, fieldMapping) => {
    const {
      mappingID,
      mapping: { source_fields: sourceFields = [] } = {},
      revvFieldID = null,
      revvSubField = null,
    } = fieldMapping;
    const { templateId } = this.props;

    if (Array.isArray(sourceFields) && sourceFields.length > 0) {
      const updatedSourceFields = sourceFields.filter(
        obj => obj.name !== fieldName,
      );
      const schema = {
        mapping: {
          ...(this.props.fieldMapping ? this.props.fieldMapping.mapping : {}),
          source_fields: updatedSourceFields,
        },
        revvFieldID,
        revvSubField,
      };
      this.props.updateFieldMapping(mappingID, schema, templateId);
    }
  };

  // _addNewRevvField = (revvFieldId, revvSubField) => {
  //   const {
  //     fieldMapping: { mappingID, mapping = {} },
  //     templateId,
  //   } = this.props;

  //   const schema = {
  //     mapping: {
  //       ...mapping,
  //     },
  //     revvFieldID: revvFieldId,
  //     revvSubField,
  //   };
  //   this.props.updateFieldMapping(mappingID, schema, templateId);
  // };

  // _removeRevvField = (revvFieldId, revvSubFieldID) => {
  //   const {
  //     fieldMapping: {
  //       mappingID,
  //       mapping = {},
  //       revvFieldID = null,
  //       revvSubField = null,
  //     },
  //     templateId,
  //   } = this.props;

  //   const schema = {
  //     mapping: {
  //       ...mapping,
  //       internal_fields: null,
  //     },
  //     revvFieldID: revvFieldID === revvFieldId ? null : revvFieldID,
  //     revvSubField: revvSubField === revvSubFieldID ? null : revvSubField,
  //   };
  //   this.props.updateFieldMapping(mappingID, schema, templateId);
  // };

  _deleteConnection = fieldMapping => {
    const { templateId } = this.props;
    this.props.removeFieldMapping(fieldMapping, templateId);
  };

  _saveTransformSettings = (updatedMapping, fieldMapping) => {
    if (updatedMapping) {
      const { templateId } = this.props;
      const { mappingID, mapping = {} } = fieldMapping;
      const schema = {
        ...fieldMapping,
        isPrimaryKey: updatedMapping.isPrimaryKey,
        mapping: {
          ...mapping,
          ...updatedMapping,
        },
      };
      this.props.updateFieldMapping(mappingID, schema, templateId);
    }
  };

  _openTransformPopup = fieldMapping => {
    if (fieldMapping) {
      const { mapping, revvFieldID } = fieldMapping;
      const { source_fields: sourceFields } = mapping;
      if (
        Array.isArray(sourceFields) &&
        sourceFields.length > 0 &&
        revvFieldID
      ) {
        this.setState({
          showTransformPopup: true,
          copyFieldMapping: fieldMapping,
        });
      }
    }
  };

  _closeTransformPopup = () => {
    this.setState({ showTransformPopup: false });
  };

  render() {
    const { copyFieldMapping: fieldMapping } = this.state;
    const sourceFields =
      fieldMapping &&
      fieldMapping.mapping &&
      Array.isArray(fieldMapping.mapping.source_fields)
        ? fieldMapping.mapping.source_fields
        : [];

    const revvFieldID = (fieldMapping && fieldMapping.revvFieldID) || null;
    const revvSubField = revvFieldID ? fieldMapping.revvSubField : null;

    const field =
      revvFieldID && Array.isArray(this.props.fieldsList)
        ? this.props.fieldsList.find(f => f.id === revvFieldID)
        : undefined;
    const checkTransformPopup = !!(
      Array.isArray(sourceFields) &&
      sourceFields.length > 0 &&
      revvFieldID
    );

    if (this.state.showTransformPopup) {
      return (
        <FieldTransformerPopup
          closeModal={this._closeTransformPopup}
          saveTransformation={this._saveTransformSettings}
          fieldMapping={this.state.copyFieldMapping}
          fieldDef={field}
          sourceObjSchema={this.props.sourceObjSchema}
          currentSelectedObject={this.props.currentSelectedObject}
          dataSourceSelected={this.props.dataSourceSelected}
          csvData={this.props.csvData}
        />
      );
    }

    return (
      <div className="source-to-revvfield-mapping">
        <RevvFieldMapperBlock
          addFieldAllowed={!revvFieldID}
          revvFieldID={revvFieldID}
          revvSubField={revvSubField}
          // addNewRevvField={this._addNewRevvField}
          addNewSourceField={this._addNewSourceField}
          // removeField={this._removeRevvField}
          removeSrcField={this._removeSourceField}
          saveMapping={this._saveFieldMapping}
          sourceFields={sourceFields}
          checkTransformPopup={checkTransformPopup}
          openTransformPopup={this._openTransformPopup}
          deleteConnection={this._deleteConnection}
          value={this.props.value}
          searchInput={this.props.searchInput}
          filterState={this.props.filterState}
          showMenuType={this.props.showMenuType}
          cardName={this.props.cardName}
          // fieldMapping={fieldMapping}
        />
      </div>
    );
  }
}

const mapStateToProps = ({
  FieldsSettingStore: {
    fieldsList,
    sourceObjSchema,
    currentSelectedObject,
    objectFieldsMapping,
    dataSourceSelected,
    csvData,
  },
}) => ({
  fieldsList,
  sourceObjSchema,
  currentSelectedObject,
  objectFieldsMapping,
  dataSourceSelected,
  csvData,
});

const mapDispatchToProps = {
  updateFieldMapping: updateFieldMappingAction,
  removeFieldMapping: removeFieldMappingAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(MappedField);
